import $ from 'jquery';
import LP from '../0-lp';
import UI from '../0-ui';


LP.dlgRandomSelection = {
    filterIds: [],

    prepare: function (selector, params) {
        var height = 500;
        $(selector).click(function () {
            if (!$(this).is('[disabled]')) {
                LP.Dialog.open($.extend(params, {
                    name: 'lp-randomselection',
                    ajax: $(this).attr('url'),
                    request: $(this).attr('url_params'),
                    title: this.title,
                    width: 800,
                    minHeight: height,
                    maxHeight: height * 1.3,
                    sizeable: true,
                    onLoad: LP.dlgRandomSelection.onLoad,
                    onClose: LP.dlgRandomSelection.onClose,
                    beforeSubmit: LP.dlgRandomSelection.beforeSubmit
                }));
            }
            return false;
        });
    },

    onLoad: function () {

        var pollId = $('#rsForm input[name="poll"]').val();

        LP.dlgRandomSelection.candidates.init(pollId);
        LP.dlgRandomSelection.wordlist.init(pollId);
        LP.dlgRandomSelection.initSpinBoxes();
        LP.dlgRandomSelection.initActionFilter();
        $('.randomSelectionType')
            .on('change', LP.dlgRandomSelection.onSwitchType) // attach change event listener
            .filter(':checked').change() // trigger the change event for the currently selected type
        ;
    },

    initSpinBoxes: function () {
        var $spinboxes = $('.lp-spinbox-box');

        $spinboxes.each(function (index, element) {
            var $spinbox = $(element);
            UI.setupSpinbox(
                $spinbox,
                $spinbox.attr('min') || '',
                $spinbox.attr('max') || '',
                $spinbox.val() || '',
                $spinbox.attr('incr') || 1,
                false,
                null,
                false,
                false,
                true);
        });
    },

    initActionFilter: function () {
        // LP.filters.init( { root : '#randomSelectionFilter .lp-filters' }  );
        // var filter = $('#randomSelectionFilter');

        var actionFilterBtn = $('a[action="actionFilterDialog"]', '#rsForm');

        LP.dlgItemFilter.prepare(actionFilterBtn, {
            afterSubmit: function (json) {
                LP.dlgRandomSelection.filterIds[LP.dlgRandomSelection.filterIds.length] = json.filterId; // wird fürs cleanup unten gespeichert
                var block = actionFilterBtn.parent();
                $('.actionFilterId', block).val(json.filterId);
            }
        });
    },

    onSwitchType: function (e) {
        var $target = $(e.target);
        var type = $target.val();
        var $fields = $('.randomSelectionFields');
        var $field = $('.randomSelectionField' + type);

        $fields.hide();
        $field.show();
    },

    onClose: function () {
        if (LP.dlgRandomSelection.filterIds.length > 0) {
            window.Browser.send('backend/clearItemFilterDialogCache/', $.param({filterids: LP.dlgRandomSelection.filterIds}));
            LP.dlgRandomSelection.filterIds = [];
        }
    },

    beforeSubmit: function () {
        return true;
    }
};

LP.dlgRandomSelection.wordlist = {

    init: function () {
        var wordlist = $('#randomSelection-wordList');

        if (!wordlist || !wordlist.html() || wordlist.html().length === 0) {
            LP.dlgRandomSelection.wordlist.addNew(wordlist, true);
        } else {
            //Da im ersten Fall innerhalb von addNew bereits initWordTerm aufgerufen wird
            $('.randomSelect-word', wordlist).each(function (index, term) {
                LP.dlgRandomSelection.wordlist.initWordTerm(term);
            });
        }
    },

    initWordTerm: function (term) {
        $('a[action="addWord"]', term).unbind('click').click(function () {
            var wordItem = $(this).closest('.randomSelect-word');
            LP.dlgRandomSelection.wordlist.addNew(wordItem, false);
        });

        $('a[action="deleteWord"]', term).unbind('click').click(function () {
            var wordItem = $(this).closest('.randomSelect-word');

            var confirmText = $('#wordremove-confirm').html();
            var onConfirm = function () {
                wordItem.remove();

                var wordlist = $('#randomSelection-wordList');
                if (wordlist.html().length === 0) LP.dlgRandomSelection.wordlist.addNew(wordlist, true);
            };
            UI.showMsgBox(confirmText, UI.MsgBox.mYESNO, onConfirm);
        });

        var itemfilterBtn = $('a[action="itemFilterDialog"]', term);

        LP.dlgItemFilter.prepare(itemfilterBtn, {
            afterSubmit: function (json) {
                LP.dlgRandomSelection.filterIds[LP.dlgRandomSelection.filterIds.length] = json.filterId; // wird fürs cleanup unten gespeichert
                LP.dlgRandomSelection.wordlist.onRefreshFilterFields();
            }
        });

        $('.lp-spinbox input', term).each(function (i, e) {
            var $e = $(e);
            UI.setupSpinbox($e, 1, '', $e.val(), 1, false, null, false, false, true, false);
        });
    },

    addNew: function (parent, appendOrInsert) {
        var template = $('#randomSelection-wordTemplate');

        var newWord = $(template.html());
        if (appendOrInsert) {
            newWord.appendTo(parent);
        } else {
            newWord.insertAfter(parent);
        }

        LP.dlgRandomSelection.wordlist.initWordTerm(newWord);
    },

    onRefreshFilterFields: function () {
        // hier werden die filter-ids, die an den kandidaten-filter-buttons im attribut "filter-id" hinterlegt sind
        // in ersatz-hidden-inputs geschrieben, weil man die sonst nicht richtig rausbekommt
        $('.randomSelect-word', '#randomSelection-wordList').each(function (index, term) {
            var filterId = $('a[action="itemFilterDialog"]', term).first().attr('filter-id');
            if (filterId) {
                $('.wordFilterId', term).val(filterId);
            } else {
                $('.wordFilterId', term).val('');
            }
        });
    }
};

LP.dlgRandomSelection.candidates = {

    init: function (pollId) {
        LP.filters.init({
            root: '#randomSelection-itemList',
            onInitTerm: LP.dlgRandomSelection.candidates.onInitCandidate,
            onDeleteTerm: LP.dlgRandomSelection.candidates.onDeleteCandidate
        });

        LP.dlgRandomSelection.candidates.initCandidates(pollId);
        LP.dlgRandomSelection.candidates.initButtonbar();
    },

    initCandidates: function (pollId) {
        /* folgende elemente werden hier "pfuschig" eingefügt, weil es für filter/prio/weight bisher nur den einen anwendungsfall gibt
         * und ich jetzt nicht gleich die filter noch mehr aufblähen wollte. die sind so schon hart genug zu verstehen.
         * sobald ein weiterer anwendungsfall dazu kommt, könnte man diese sachen hier */
        var filterbtnHTML = '<a class="grey-btn small icon-filter" action="itemFilterDialog" url_params="poll=' + pollId + '&filterType=candidate&saveMode=session"></a>';
        var priorityField = '<span class="lp-spinbox"><input type="text" class="cand-prio" name="itemlistfilter[priority][]" size="5"><span class="lp-spinbox-button spinUp"></span><span class="lp-spinbox-button spinDown"></span></span>';
        var weightField = '<span class="lp-spinbox"><input type="text" class="cand-weight" name="itemlistfilter[weight][]" size="5"><span class="lp-spinbox-button spinUp"></span><span class="lp-spinbox-button spinDown"></span></span>';

        $('.filterTerm', '#randomSelection-itemList').each(function (index, term) {
            // loopt alle sichtbaren terme, sowie das (unsichtbare) template für neue terme
            var $term = $(term);
            var termIndex = $('.termIndex', $term).val();
            var $buttonbar = $('.button-bar', $term);

            // add candidate filter
            var $filterBtn = $(filterbtnHTML);
            var filterId = $('#rsForm input[name="candFilter[' + termIndex + ']"]').val();
            if (filterId) {
                $filterBtn.attr('filter-id', filterId);
            }
            $buttonbar.prepend($filterBtn);

            // add container for extra spinboxes
            var $extraFields = $('<div class="button-bar extra-fields"></div>');
            // add (prepend) weight-field
            var $weightField = $(weightField);
            var weightValue = $('#rsForm input[name="candWeight[' + termIndex + ']"]').val();
            if (weightValue) {
                $('input', $weightField).val(weightValue);
            }
            $extraFields.prepend($weightField);

            // add (prepend) priority-field
            var $priorityField = $(priorityField);
            var prioValue = $('#rsForm input[name="candPrio[' + termIndex + ']"]').val();
            if (prioValue) {
                $('input', $priorityField).val(prioValue);
            }
            $extraFields.prepend($priorityField);

            $extraFields.insertBefore($buttonbar);

            LP.dlgRandomSelection.candidates.onInitCandidate($term);
        });

    },

    initButtonbar: function () {
        var $firstButtonbar = $('.lp-filter-terms .filterTerm .extra-fields', '#randomSelection-itemList').first();
        var labels = $('#candidate-labels').detach();
        $firstButtonbar.prepend(labels);
    },

    onInitCandidate: function ($term) {
        var $itemfilterBtn = $('a[action="itemFilterDialog"]', $term);

        LP.dlgItemFilter.prepare($itemfilterBtn, {
            afterSubmit: function (json) {
                LP.dlgRandomSelection.filterIds[LP.dlgRandomSelection.filterIds.length] = json.filterId; // wird fürs cleanup unten gespeichert
                LP.dlgRandomSelection.candidates.onRefreshFilterFields();
            }
        });

        $('.lp-spinbox input', $term).each(function (i, e) {
            var $e = $(e);
            UI.setupSpinbox($e, 1, '', $e.val(), 1, false, null, false, false, true, false);
        });
    },

    onDeleteCandidate: function () {
        LP.dlgRandomSelection.candidates.onRefreshFilterFields();
    },

    onRefreshFilterFields: function () {
        // hier werden die filter-ids, die an den kandidaten-filter-buttons im attribut "filter-id" hinterlegt sind
        // in ersatz-hidden-inputs geschrieben, weil man die sonst nicht richtig rausbekommt
        $('input[name^=candFilter]').remove();
        $('.filterTerm', '#randomSelection-itemList').each(function (index, term) {
            var filterId = $('a[action="itemFilterDialog"]', term).first().attr('filter-id');
            var termIndex = $('.termIndex', term).val();
            if (filterId) {
                $('<input type=hidden name="candFilter[' + termIndex + ']" value="' + filterId + '" />').appendTo($('#rsForm'));
            }
        });
    }

};